<template>
  <div class="container_wrap">
    <div class="text">
      <ul>
        <li @click="jumpTo(tab)" v-for="(tab, index) in navTabs" :key="index">{{tab.name}}</li>
      </ul>
      <div class="gz textColor">
        <span>关注新界</span>
        <a class="a1" title="微信" @click="isShowWxQr =!isShowWxQr">
          <img src="@/assets/img/icon/ruzhu-02.png" />
          <img v-if="isShowWxQr" class="qrcode" src="@/assets/img/wxcode.png" />
        </a>
        <a class="a1" title="微博" @click="isShowWeiboQr =!isShowWeiboQr">
          <img src="@/assets/img/icon/ruzhu-03.png" />
          <img v-if="isShowWeiboQr" class="qrcode" src="@/assets/img/weibo.png" />
        </a>
        <a class="a1" title="抖音" @click="isShowDyQr =!isShowDyQr">
          <img   src="@/assets/img/icon/ruzhu-04.png" />
          <img   v-if="isShowDyQr" class="qrcode" src="@/assets/img/dy.png" />
        </a>
        <span class="a2 textColor" v-on:mouseover="isShowPic=!isShowPic">
          下载APP
          <img v-if="isShowPic" src="@/assets/img/erweima.png" />
        </span>
        <!-- <a href class="footerimg">
          <img src="@/assets/img/footerimg.jpg" alt />
        </a> -->
      </div>
      <!-- <div class="logo">
        <img src="@/assets/img/logo.jpg" alt />
      </div> -->
      <div></div>
      <div class="bq">
        <p>
          <span>
            上海青邻公寓管理有限公司 上海市松江区泗泾镇米易路45弄
            <br />Copyright@2020 版权所有
          </span>
          <span>备案：</span>
          <span>沪ICP 备18045760号-1</span>
          <a href target="_blank">
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowPic: false,
      isShowDyQr:false,
      isShowWeiboQr:false,
      isShowWxQr:false,
      navTabs: [
        { path: "/", name: "首页" },
        { path: "/about", name: "关于新界" },
        { path: "/search", name: "房源搜索" },
        { path: "/hui", name: "新界活动" },
        { path: "/customer", name: "企业客户" },
        { path: "/contact", name: "联系新界" }
      ]
    };
  },
  methods: {
    jumpTo(tab) {
      this.$router.push(tab.path);
    }
  }
};
</script>

<style scoped lang="scss">
.container_wrap {
  background: #3b585b;
  padding: 13px 3% 10px 3%;
  width: 100%;
  overflow: hidden;
  .text {
    width: 100%;
    ul {
      overflow: hidden;
      padding: 0;
      li {
        color: #fff;
        float: left;
        margin-right: 18px;
        font-size: 13px;
        line-height: 25px;
        letter-spacing: 1px;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .gz {
      width: 100%;
      // margin-top: 22px;
      // padding: 30px 0;
      span {
        float: left;
        display: block;
        font-size: 16px;
        line-height: 33px;
        letter-spacing: 1px;
      }
      .a1 {
        position: relative;
        margin-left: 15px;
        width: 33px;
        height: 33px;
        img {
          width: 33px;
          height: 33px;
        }
        .qrcode{
    width: 180px;
    height: 240px;
    position: absolute;
    left: -72px;
    bottom: -33px;
        }
      }
      .a2 {
        margin-left: 20px;
        font-size: 16px;
        position: relative;
        line-height: 32px;
        letter-spacing: 1px;
        cursor: pointer;
        img {
          width: 100px;
          height: 100px;
          position: absolute;
          left: -2px;
          top: 30px;
        }
      }
      .footerimg {
        img{
        width: 200px;
        position: absolute;
        right: 0px;
        }
      }
    }
    .logo {
      margin-left: -35px;
      img {
        width: 200px;
      }
    }
    .bq {
      font-size: 12px;
      color: white;
      line-height: 18px;
      opacity: 0.7;
    }
  }
}
</style>
